import { PropertyExplanationModal } from '@coolblue-development/next-hemingway/client';
import { UsbCChargerIncluded as BaseComponent } from '@coolblue-development/next-patterns/client';
import type { ComponentProps } from 'react';

export type USBCChargerIncludedTrackingFeatureName = ComponentProps<
  typeof BaseComponent
>['trackingFeatureName'];

export function USBCChargerIncluded({
  hasUsbCChargerIncluded,
  trackingFeatureName
}: {
  hasUsbCChargerIncluded?: boolean;
  trackingFeatureName?: ComponentProps<typeof BaseComponent>['trackingFeatureName'];
}) {
  return (
    <BaseComponent
      hasUsbCChargerIncluded={hasUsbCChargerIncluded}
      propertyExplanationModal={PropertyExplanationModal}
      {...(trackingFeatureName && { trackingFeatureName })}
    />
  );
}
